class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");

    // this.detailsContainer.addEventListener(
    //   "keyup",
    //   (event) => event.code.toUpperCase() === "ESCAPE" && this.close(),
    // );

    this.summaryToggle.addEventListener(
      "click",
      this.onSummaryClick.bind(this),
    );
    this.querySelectorAll('button[type="button"]').forEach((e) =>
      e.addEventListener("click", this.close.bind(this)),
    );

    this.summaryToggle.setAttribute("role", "button");

    this.animationTimer = parseInt(
      this.getAttribute("data-animation-timer") ?? "0",
    );
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest("details").hasAttribute("open")
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains("modal-overlay")
    )
      this.close(false);
  }

  async open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.detailsContainer.setAttribute("open", true);

    if (this.animationTimer) {
      // wait for adding the open attribute to the details element
      await sleep(1);
      const ELM_content =
        this.detailsContainer.querySelector(".modal__content");
      ELM_content.classList.add("active");
    }

    if (this.classList.contains("header__search")) {
      document
        .querySelector(".shopify-section-group-header-group")
        .addEventListener("click", this.onBodyClickEvent);
    } else {
      document.documentElement.addEventListener("click", this.onBodyClickEvent);
    }

    document.documentElement.classList.add("overflow-hidden");
    document.documentElement.style.height = "100dvh";

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])'),
    );

    this.currrentScrollYPosition = window.scrollY;
  }

  async close(focusToggle = true) {
    if (this.animationTimer) {
      const ELM_content =
        this.detailsContainer.querySelector(".modal__content");
      ELM_content.classList.remove("active");
      // wait for the animation to finish, then remove the open attribute in 301ms
      await sleep(this.animationTimer + 1);
    }

    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute("open");

    if (this.classList.contains("header__search")) {
      document
        .querySelector(".shopify-section-group-header-group")
        .removeEventListener("click", this.onBodyClickEvent);
    } else {
      document.documentElement.removeEventListener(
        "click",
        this.onBodyClickEvent,
      );
    }

    const isProductRecommendationsModal =
      this.detailsContainer.classList.contains(
        "pd-product-recommendations-modal",
      );
    const cartDrawer = document.querySelector("cart-drawer");

    const shouldRemoveOverflow =
      !isProductRecommendationsModal ||
      (cartDrawer && !cartDrawer.classList.contains("active"));

    if (shouldRemoveOverflow) {
      document.documentElement.classList.remove("overflow-hidden");
      document.documentElement.style.height = "unset";
    }

    window.scrollTo(0, this.currrentScrollYPosition);
  }
}

customElements.define("details-modal", DetailsModal);
